import React, { useEffect, useState } from 'react';
import DocumentService from '../../../../services/documents/document';
import LoadingComponent from '../../../feedbacks/loading';

type TypeRenderImageProps = {
  children?: React.ReactNode;
  path: string
  className?: string
  alt?: string
  style?: React.CSSProperties
};

const RenderImage: React.FC<TypeRenderImageProps> = (props) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const getIamgeData = async () => {
    try {
      setLoading(true);
      setError(false);
      const res = await DocumentService.get(props.path);
      const blob = res?.data?.data || res?.data || res;
      if (!blob || typeof blob !== 'string') {
        setError(true);
      } else {
        setImageSrc(blob);
      }
    } catch (err) {
      console.log(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getIamgeData();
  }, [props.path]);

  const getSrc = () => {
    if (!imageSrc) return '';
    if (imageSrc.startsWith('data:')) return imageSrc;
    const ext = props.path ? props.path.split('.').pop()?.toLowerCase() : 'jpeg';
    let mime = 'image/jpeg';
    if (ext === 'png') mime = 'image/png';
    else if (ext === 'gif') mime = 'image/gif';
    else if (ext === 'webp') mime = 'image/webp';
    else if (ext === 'svg') mime = 'image/svg+xml';
    return `data:${mime};base64,${imageSrc}`;
  };

  return (
    <>
      {loading ? <LoadingComponent label={''} /> : null}
      {!loading && imageSrc && !error ? (
        <img
          style={props.style}
          className={props.className}
          src={getSrc()}
          alt={props.alt || "Gambar"}
          onError={() => setError(true)}
        />
      ) : null}
      {!loading && (error || !imageSrc) ? (
        <span style={{ fontSize: '11px', color: '#8a8886', fontStyle: 'italic' }}>
          [Gambar tidak dapat dimuat]
        </span>
      ) : null}
    </>
  );
};

export default RenderImage;
